import request from 'utils/request';
import { DictionaryDto, PagedView } from './dictionary';

export const fetchRoles = (): Promise<PagedView<DictionaryDto>> => {
    return request
        .get('/user-role', { params: { page: 0, size: 1000, sort: 'id,asc', value: '' } })
        .then(({ data }) => data as PagedView<DictionaryDto>);
};
